import React from 'react'
import styled from '@emotion/styled'
import { severityColors } from 'style/theme'
import { MoreItems } from 'components'
import SelectorColumn, {SelectorNotAllowedInTrial} from '../../Scan/components/SelectorColumn';
import {UNAVAILABLE_FOR_TRIAL} from '../../Scan/index';

const DocumentError = styled.div({
	fontWeight: "bold"
})

const ErrorStyle = styled.a(props => ({
	fontWeight: 700,
	fontSize: '0.8rem',
	borderRadius: 20,
	padding: '4px 10px',
	background: 'none',
	color: props.tagcolor,
	border: 'none',
	cursor: 'pointer',
	textDecoration: 'underline',
	'&:hover': {
		textDecoration: 'underline'
	}
}))

const Title = styled.span(props => ({
	fontWeight: 700,
	color: 'gray'
}))



const wcagDomain = `https://docs.wcag.online`;

export default [
	{
		title: 'SELECTORS',
		dataIndex: 'selector',
		width: '25%',
		render: (selector, entity) => {
			selector = selector ? selector : (<DocumentError>#document</DocumentError>)
			return (
				<>
					{
						selector === UNAVAILABLE_FOR_TRIAL
						?
						<SelectorNotAllowedInTrial selector={selector} />
						:
						<SelectorColumn cls="selector" selector={selector} />
					}
				</>
			)
		}
	},
	{
		title: 'ELEMENT ID',
		dataIndex: 'html_element_id',
		render: (elementId, entity) => {
			elementId = elementId ? "#" + elementId : "-"
			return (
				<>
					{
						elementId === UNAVAILABLE_FOR_TRIAL
						?
						<SelectorNotAllowedInTrial selector={elementId} />
						:
						<SelectorColumn cls="selector" selector={elementId} />
					}
				</>
			)
		}
	},
	{
		title: 'CLASS NAME',
		dataIndex: 'class_name',
		render: (className, entity) => {
			className = className ? "." + className : "-"
			return (
				<>
					{
						className === UNAVAILABLE_FOR_TRIAL
						?
						<SelectorNotAllowedInTrial selector={className} />
						:
						<SelectorColumn cls="selector" selector={className} />
					}
				</>
			)
		}
	},
	{
		title: 'ERROR',
		dataIndex: 'error',
		render(error, entity) {
			const color = entity && entity.severity && severityColors[entity.severity.toLowerCase()]
			return <ErrorStyle href={`${wcagDomain}${entity.url}`} target="_blank" tagcolor={color}>{error}</ErrorStyle>
		}
	},
	{
		title: 'TITLE',
		dataIndex: 'title',
		render(title, entity) {
			return <Title>{title}</Title>
		}
	},
	{
		title: 'LABELS',
		dataIndex: 'labels',
		render(labels, entity) {
			var labels_arr = labels && labels.length 
				? labels.map((label) => {
					let item = { "name" : label };
					if(entity.document_labels && entity.document_labels.hasOwnProperty(label)){
						item.tooltip = entity.document_labels[label].selector;
					}

					return item;
				})
				: [];

			return <MoreItems items={labels_arr} />
		}
	}
]
